import React from 'react';
import WizardCard from '../../components/WizardCard/WizardCard';
import Appear from '../../components/Appear/Appear';
import withContainer from '../../containers/WithContainer';
import AppContainer, { ContainerNew } from '../../containers/AppContainer';

interface FinishProps {
  appContainer: ContainerNew;
}
const Finish: React.FunctionComponent<FinishProps> = props => {
  const provider = props.appContainer.state.provider;

  let homeormobile;
  if (provider.offersHome && provider.offersMobile) {
    homeormobile = 'both'
  } else if (provider.offersHome && !provider.offersMobile) {
    homeormobile = 'home'
  } else {
    homeormobile = 'mobile'
  }

  console.log(props.appContainer.state.provider);


  return (
    <WizardCard
      title="Application Submitted"
      subTitle="We will get back to you within 48 hours after your profile has been reviewed."
      isPrevHidden
      isNextHidden
      nextLabel="Finish & Go To Dashboard"
      isDisabled={false}
      delay={4}
      isLoading={props.appContainer.state.loading}
    >
      <Appear className="has-margin-top-30">
        <div className="has-text-centered has-text-grey has-margin-top-4">
          <a
            href={`https://withflayr.typeform.com/to/tPPiC5?provider_id=${
              props.appContainer.state.step1.provider_id
              }&homeormobile=${homeormobile}`}
            className="button is-primary"
          >
            Setup Your Prices
          </a>
        </div>
        <div className="has-text-centered has-margin-top-20">
          Please tag <strong>@withflayr</strong> on your latest instagram post
          so we can verify your account.
        </div>

        <div className="has-text-centered has-text-grey has-margin-top-20">
          Be sure to <strong>make your Insta profile public</strong>
        </div>


      </Appear>
    </WizardCard>
  );
};

export default withContainer(Finish);
